import { AuthRoute } from '@/system-modules/auth/v1/api/AuthRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { AuthResult } from '@/contracts/system-modules/auth/dto/auth/AuthResult'
import { RegisterParams } from '@/system-modules/auth/v1/api/v1/auth/Register/Dto/RegisterParams'

export const OFFLINE_DEVICE_UUID = '0ff11e00-0000-4000-8000-000000000001'
// имя — имя сеанса: первые 8 символов UUID устройства
export const OFFLINE_USER = { uuid: '1b8a2a86-9e75-440d-a96d-ab620c18beb2', name: '0ff11e00' }

export function offlineAuthResult(): AuthResult {
  return new AuthResult({
    token: 'offline-token',
    expiresAt: new Date(Date.now() + 900000).toISOString(),
    deviceUuid: OFFLINE_DEVICE_UUID,
    user: OFFLINE_USER,
    hasPins: true,
  })
}

export class RegisterRoute extends AuthRoute<RegisterParams, AuthResult> {
  type(): EnumRouteType {
    return EnumRouteType.POST
  }

  url(): string {
    return '/api/system/v1/auth/register'
  }

  offline(params: RegisterParams): Promise<ApiResponse<AuthResult>> {
    if (params.pin === params.resetPin) {
      return Promise.resolve(new ApiResponse({ success: false, error: 'invalid_pin' }))
    }

    return Promise.resolve(new ApiResponse({ success: true, data: offlineAuthResult() }))
  }
}
